import script from "./DayBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./DayBlock.vue?vue&type=script&setup=true&lang=ts"

import "./DayBlock.vue?vue&type=style&index=0&id=279423ef&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279423ef"]])

export default __exports__